import React from "react";
import Menu from "../Components/Menu";

const Festival = () => {
    return (
        <div className="container">
            <div className="emp-main">
                <p className="emp-text fos-big"> به زودی</p>
            </div>
            <Menu active="festival" />
        </div>
    );
};

export default Festival;
